module.exports = __webpack_public_path__ + "img/user-avatar.1321c72a.jpeg";